import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import { Context } from "../../../../../utils/context";
import { postData, getData } from "../../../../../utils/api";
import SuccessModal from "../../../../Common_modal/Successfull_Modal/Successfull_Modal";
import CongratsSuccessmodal from "../../../../Common_modal/CongratsSuccessmodal/CongratsSuccessmodal";
import { useNavigate } from "react-router-dom";

const Step_Four_New = ({ prevStep }) => {
  const navigate = useNavigate();
  const { postData: contextPostData, getData: contextGetData } =
    useContext(Context);

  const user_id = Cookies.get("seller_user_id") || "";
  const [contactNo, setContactNo] = useState("");

  const [showOtp, setShowOtp] = useState("");
  const [otpInputs, setOtpInputs] = useState(["", "", "", ""]);
  const [fields, setFields] = useState(false);
  const [noVerified, setNoVerified] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [modalShow1, setModalShow1] = useState(false);
  const [show, setShow] = useState(false);
  const [errorGetOtp, setErrorGetOtp] = useState("");

  const inputRefs = useRef([]);

  const handleClose = () => setShow(false);

  const loadContactNumber = async () => {
    if (!user_id) return;
    try {
      const res = await contextGetData(`/seller/seller-bank-detail/${user_id}`);
      if (res?.success && res.data?.seller_bank_detail) {
        const contact =
          res.data.contact_no || res.data.seller_bank_detail?.contact_no;
        if (contact) setContactNo(contact);
      }
    } catch (err) {
      console.log("Could not load contact number");
    }
  };

  useEffect(() => {
    if (user_id) loadContactNumber();
  }, [user_id]);

  // Focus first input when OTP field appears
  useEffect(() => {
    if (fields && inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, [fields]);

  const handleOtpInputChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newOtpInputs = [...otpInputs];
    newOtpInputs[index] = value;
    setOtpInputs(newOtpInputs);

    if (value.length === 1 && index < 3) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleBackspace = (index, e) => {
    if (e.key === "Backspace" && !otpInputs[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  // Send OTP
  const GetOtp = async () => {
    setShowOtp(true);
    setErrorGetOtp("");
    setOtpInputs(["", "", "", ""]);
    if (!contactNo) {
      setErrorGetOtp("Contact number not available");
      return;
    }

    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("contact_no", contactNo);

    try {
      const res = await contextPostData("/seller/add-four", formData);
      if (res?.success) {
        setFields(true);
        setModalShow(true);
        setSeconds(30);
        setTimeout(() => setModalShow(false), 3000);
      } else {
        setErrorGetOtp(res?.message || "Failed to send OTP");
      }
    } catch (err) {
      setErrorGetOtp("Network error");
    }
  };

  // Verify OTP
  const VerifyOtp = async () => {
    const otp = otpInputs.join("");
    if (otp === "") {
      setErrorGetOtp("OTP is required");
      return;
    }
    setErrorGetOtp("");
    const data = {
      contact_no: contactNo,
      otp: otp,
    };

    try {
      const res = await contextPostData(
        "/seller/add-five-mobile-verify-otp",
        data,
      );
      if (res?.success) {
        setNoVerified(true);
        setModalShow1(true);
        setTimeout(() => setModalShow1(false), 3000);
      } else {
        setErrorGetOtp(res?.message || "Invalid OTP");
      }
    } catch (err) {
      setErrorGetOtp("Verification failed");
    }
  };

  // Timer
  useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [seconds]);

  // Final Submit - Navigate to Home
  const onsubmit = () => {
    if (!noVerified) {
      setErrorGetOtp("Please verify your mobile number first");
      return;
    }

    setShow(true); // Show congrats modal
    Cookies.remove("seller_user_id");

    setTimeout(() => {
      navigate("/"); // Redirect to home after 3 seconds
    }, 3000);
  };

  return (
    <section className="personal-details-form Step_Four_New">
      <div>
        <Form>
          <div>
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="Step_Four_NewMain">
                  <p className="info_text">
                    Verify Your Contact Number (Verify OTP to digitally sign the
                    documents)
                  </p>

                  <Form.Group
                    className="mb-3 position-relative"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Contact No"
                      value={contactNo}
                      disabled
                    />
                    {noVerified && (
                      <FontAwesomeIcon
                        icon={faCircleCheck}
                        style={{
                          position: "absolute",
                          right: "15px",
                          top: "12px",
                          color: "green",
                          fontSize: "20px",
                        }}
                      />
                    )}
                  </Form.Group>

                  {errorGetOtp && <p style={{ color: "red" }}>{errorGetOtp}</p>}
                </div>
              </div>

              <div className="col-lg-12 col-md-12">
                <div className="right_side">
                  {noVerified ? (
                    <p className="getotptxt" style={{ color: "green" }}>
                      Verified
                    </p>
                  ) : !showOtp ? (
                    <div className="apply_now_btn otp_btn">
                      <Button
                        className="tabs-btn"
                        type="button"
                        onClick={GetOtp}
                      >
                        Get OTP
                      </Button>
                    </div>
                  ) : (
                    <></>
                  )}

                  {!noVerified && (
                    <div className="otp_input_holder">
                      {fields && (
                        <>
                          {seconds > 0 && (
                            <div className="">
                              <Form.Label>Enter OTP</Form.Label>
                              <div className="getotpinput">
                                {Array.from({ length: 4 }, (_, i) => (
                                  <div className="otp_input_div" key={i}>
                                    <Form.Control
                                      type="text"
                                      maxLength="1"
                                      value={otpInputs[i]}
                                      onChange={(e) =>
                                        handleOtpInputChange(i, e.target.value)
                                      }
                                      onKeyDown={(e) => handleBackspace(i, e)}
                                      ref={(input) =>
                                        (inputRefs.current[i] = input)
                                      }
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          <div className="get-otp ">
                            {seconds > 0 && (
                              <p className="otp otptimer">
                                Enter OTP within{" "}
                                {`${Math.floor(seconds / 60)}:${(seconds % 60)
                                  .toString()
                                  .padStart(2, "0")}`}{" "}
                                seconds
                              </p>
                            )}
                            {seconds === 0 && (
                              <span
                                style={{ cursor: "pointer" }}
                                className="clickresend"
                                onClick={GetOtp}
                              >
                                Click to Resend.
                              </span>
                            )}
                          </div>

                          {seconds > 0 && (
                            <div className="">
                              <div className="text-start apply_now_btn otp_btn">
                                <Button
                                  className="tabs-btn"
                                  type="button"
                                  onClick={VerifyOtp}
                                >
                                  Verify
                                </Button>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="text-start apply_now_btn">
            <div className="registerContinueMain">
              <Button onClick={prevStep} className="back-btn me-3">
                Back
              </Button>
              <Button className="tabs-btn" type="button" onClick={onsubmit}>
                Complete Registration
              </Button>
            </div>
          </div>
        </Form>
      </div>

      <SuccessModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        message="OTP Sent"
        subMessage="Enter the OTP and Verify the Number"
      />

      <SuccessModal
        show={modalShow1}
        onHide={() => setModalShow1(false)}
        message="OTP Verified"
      />

      <CongratsSuccessmodal
        show={show}
        handleClose={() => {
          setShow(false);
          navigate("/");
        }}
      />
    </section>
  );
};

export default Step_Four_New;
